// @ts-nocheck

/**
 * * `software` - software
 * `unlimited` - unlimited
 * `credit_pack` - credit_pack
 * `physical_book` - physical_book
 */
export type CartLineKindEnum =
  typeof CartLineKindEnum[keyof typeof CartLineKindEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CartLineKindEnum = {
  software: "software",
  unlimited: "unlimited",
  credit_pack: "credit_pack",
  physical_book: "physical_book",
} as const;
